/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthSubmissionStatus } from './PalAuthSubmissionStatus';
import {
    PalAuthSubmissionStatusFromJSON,
    PalAuthSubmissionStatusFromJSONTyped,
    PalAuthSubmissionStatusToJSON,
} from './PalAuthSubmissionStatus';

/**
 * 
 * @export
 * @interface PalAuthSubmissionStatusInfo
 */
export interface PalAuthSubmissionStatusInfo {
    /**
     * 
     * @type {PalAuthSubmissionStatus}
     * @memberof PalAuthSubmissionStatusInfo
     */
    status: PalAuthSubmissionStatus;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionStatusInfo
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionStatusInfo
     */
    level?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionStatusInfo
     */
    contact_status?: PalAuthSubmissionStatusInfoContactStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionStatusInfo
     */
    outcome?: PalAuthSubmissionStatusInfoOutcomeEnum;
}


/**
 * @export
 */
export const PalAuthSubmissionStatusInfoContactStatusEnum = {
    Contacted: 'contacted',
    DidNotReach: 'did_not_reach'
} as const;
export type PalAuthSubmissionStatusInfoContactStatusEnum = typeof PalAuthSubmissionStatusInfoContactStatusEnum[keyof typeof PalAuthSubmissionStatusInfoContactStatusEnum];

/**
 * @export
 */
export const PalAuthSubmissionStatusInfoOutcomeEnum = {
    RevisedAuth: 'revised_auth',
    WouldNotContactPayer: 'would_not_contact_payer',
    AttemptedUnableToReach: 'attempted_unable_to_reach',
    DidNotAttempt: 'did_not_attempt'
} as const;
export type PalAuthSubmissionStatusInfoOutcomeEnum = typeof PalAuthSubmissionStatusInfoOutcomeEnum[keyof typeof PalAuthSubmissionStatusInfoOutcomeEnum];


/**
 * Check if a given object implements the PalAuthSubmissionStatusInfo interface.
 */
export function instanceOfPalAuthSubmissionStatusInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function PalAuthSubmissionStatusInfoFromJSON(json: any): PalAuthSubmissionStatusInfo {
    return PalAuthSubmissionStatusInfoFromJSONTyped(json, false);
}

export function PalAuthSubmissionStatusInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionStatusInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': PalAuthSubmissionStatusFromJSON(json['status']),
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'level': !exists(json, 'level') ? undefined : json['level'],
        'contact_status': !exists(json, 'contact_status') ? undefined : json['contact_status'],
        'outcome': !exists(json, 'outcome') ? undefined : json['outcome'],
    };
}

export function PalAuthSubmissionStatusInfoToJSON(value?: PalAuthSubmissionStatusInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': PalAuthSubmissionStatusToJSON(value.status),
        'comment': value.comment,
        'level': value.level,
        'contact_status': value.contact_status,
        'outcome': value.outcome,
    };
}

